;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './Grid.module.scss';

const Grid = ({ children, tag = 'div', className = '' }) => {
    const Tag = tag;
    return (
        <Tag className={cx(styles.gridContainer, className)}>{children}</Tag>
    );
};

Grid.propTypes = {
    children: PropTypes.node.isRequired,
    tag: PropTypes.string,
    className: PropTypes.string,
};

export default Grid;
